/**
 * Allows you to add data-method="METHOD to links to automatically inject a form
 * with the method on click
 *
 * Example: <a href="{{route('customers.destroy', $customer->id)}}"
 * data-method="delete" name="delete_item">Delete</a>
 *
 * Injects a form with that's fired on click of the link with a DELETE request.
 * Good because you don't have to dirty your HTML with delete forms everywhere.
 */
function addDeleteForms() {
    $('[data-method]').append(function () {
        if (!$(this).find('form').length > 0) {
            return "\n<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                "<input type='hidden' name='_method' value='" + $(this).attr('data-method') + "'>\n" +
                "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                '</form>\n';
        } else { return '' }
    })
        .attr('href', '#')
        .attr('style', 'cursor:pointer;')
        .attr('onclick', '$(this).find("form").submit();');
}

/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Add the data-method="delete" forms to all delete links
     */
    addDeleteForms();

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        $(this).find('input[type="submit"]').attr('disabled', true);
        $(this).find('button[type="submit"]').attr('disabled', true);
        return true;
    });

    /**
     * Generic confirm form delete using Sweet Alert
     */
    $('body').on('submit', 'form[name=delete_item]', function (e) {
        e.preventDefault();

        const form = this;
        const link = $('a[data-method="delete"]');
        const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
        const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Yes, delete';
        const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : 'Are you sure you want to delete this item?';

        Swal.fire({
            title: title,
            showCancelButton: true,
            confirmButtonText: confirm,
            cancelButtonText: cancel,
            icon: 'warning'
        }).then((result) => {
            result.value && form.submit();
        });
    }).on('click', 'a[name=confirm_item]', function (e) {
        /**
         * Generic 'are you sure' confirm box
         */
        e.preventDefault();

        const link = $(this);
        const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : 'Are you sure you want to do this?';
        const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
        const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Continue';

        Swal.fire({
            title: title,
            showCancelButton: true,
            confirmButtonText: confirm,
            cancelButtonText: cancel,
            icon: 'info'
        }).then((result) => {
            result.value && window.location.assign(link.attr('href'));
        });
    }).on('click', 'a[name=change_status]', function (e) {
        /**
         * Generic 'are you sure' confirm box
         */
        e.preventDefault();

        const link = $(this);
        const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : 'Are you sure you want to do this?';
        const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
        const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Continue';

        Swal.fire({
            title: title,
            input: 'select',
            inputOptions: {
                'Registered': 'Registered',
                'Ready': 'Ready',
                'Picked-Up': 'Picked-Up',
                'In Transit': 'In Transit',
                'Completed': 'Completed',
                'Declined': 'Declined'
            },
            showCancelButton: true,
            confirmButtonText: confirm,
            cancelButtonText: cancel,
            icon: 'info',

        }).then((result) => {
            result.value && window.location.assign(link.attr('href')+'?'+new URLSearchParams({
                        status: result.value
                    }));
        });
    }).on('click', 'a[name=recheck]', function (e) {
        /**
         * Generic 'are you sure' confirm box
         */
        e.preventDefault();

        const link = $(this);

        const code = link.attr('data-code');
        const value = link.find('span').text();

        Swal.fire({
            title: 'Recheck weight',
            input: 'number',
            inputAttributes: {'step': 0.01},
            inputValue: value,
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            icon: 'info',
            showLoaderOnConfirm: true,
            preConfirm: (login) => {
                return fetch('/admin/order/recheck',{
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        code: code,
                        value: login
                    })
                }).then(response => {
                    if (!response.ok) {
                      throw new Error(response.message)
                    }
                    return response.json()
                  })
                  .catch(error => {
                    Swal.showValidationMessage(
                      `Request failed: ${error}`
                    )
                  })
            }

        }).then((result) => {
            if (result.isConfirmed) {
                window.location.reload()
            }
        });
    });


    $('body').on('click','.getStatus', function(e){
        e.preventDefault();
        const _this = $(this)
        var code = _this.attr('data-code')
        getThirdPartyStatus(code)

    }).on('click','.changeStatus', function(e){
        e.preventDefault();
        const _this = $(this)
        var id = _this.attr('data-id')
        var code = _this.attr('data-code')
        changeInTransitStatus(id, code)

    })

    function changeInTransitStatus(id, code){
        Swal.fire({
            title: "Ndrysho statusin per porosine "+code,
            input: 'select',
            inputOptions: {
                '': '',
                'Delivered': 'Dorezuar',
                'Declined': 'Anuluar'
            },
            showCancelButton: true,
            confirmButtonText: "Ndrysho",
            cancelButtonText: "Kthehu",
            icon: 'info',
            preConfirm: (status) => {
                return fetch('/admin/order/'+id+'/change_status',{
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        status: status
                    })
                }).then(response => {

                    if (!response.ok) {
                        throw new Error(response.message)
                    }
                    return response.json()
                }).catch((error) => {
                    console.log(error)
                    Swal.showValidationMessage(
                        `Request failed: ${error}`
                    )
                })
            }

        }).then((result) => {
            if (result.isConfirmed) {
                window.location.reload()
            }
        });
    }

    function showSwalTracking(content,code)
    {

        Swal.fire({
            title: 'Gjurmi i porosise '+code,
            html: content
        })
    }

    function getThirdPartyStatus(code) {

        $.ajax({
            url:'/admin/order/'+code+'/status',
            dataType:'html',
            success: function(result) {
                console.log(result)
                //return result.receiver_name
                showSwalTracking(result, code)
            }
        })
    }

    $('[data-toggle="tooltip"]').tooltip();



    $.fn.selectpicker.Constructor.BootstrapVersion = '4';



});
